export const APPFUNC = [
    'Shipping', 'Marketing', 'Pick-and-Pack', 'Predictive-Pricing', 'Realtime-Pricing', 'MSSQL', 'Social-Blanket', 'Risk-Modeling', 'Storefront-API', 'Web-App-SF-Home',
    'DB-Event-Orders', 'Product-Ratings', 'Warehouse-Management', 'Ticket-Generation', 'WindowsUpdateServer', 'IT', 'Blog-Runner', 'Social-Sockets', 'HR', 'Clients',
];
export const APPNAME = [
    'Marketing', 'Big-Data-Analytics', 'Employee-Cafe', '3rd-Party-Suppliers', 'Unknown', 'Events', 'Databases', 'SharedServices', '3rd-Party-Credit-Bureau',
    'Sensitive-Databases', 'Payments', 'Storefront', 'Clients', 'ERP', '3rd-Party-Logistics', 'Users', 'FileServers', 'eCommerce',
];
export const WL = {
    Realm: ['Clients', 'PROD', 'Internet'],
    Region: ['AC-DC', 'Unknown', 'AWS-US-East', 'Oregon-DC', 'Internet', 'Clients', 'Azure-Central-US', 'NewYork-DC', 'AWS-US-West'],
    PCI: ['Category-2c', 'Category-2b', 'Category-2a', 'Category-1a', 'Category-3'],
    PII: ['Yes', 'No'],
    System: ['Internal'],
    Criticality: ['1', '2', '3', '4', '5'],
};
export const DL = {
    Managed: ['tanium'],
    Type: ['Android', 'iOS', 'MacOS', 'Linux', 'Windows'],
};
export const UL = {
    Department: ['Buyer, industrials', 'Embryologist, clinicals', 'Psychologist, clinicals', 'Designer, television/film sets'],
    Division: ['Division0', 'Division1'],
    Location: ['Canada', 'United Arab Emirates', 'United Kingdom', 'United States of America'],
};
export const SERVICES = ['tcp:139', 'tcp:1433', 'tcp:22', 'tcp:25', 'tcp:3389', 'tcp:443', 'tcp:445', 'tcp:50070', 'tcp:50075'];

export const CATEGORY = {
    'Workload Label': WL,
    'User Label': UL,
    'Device Label': DL,
    'AppName': APPNAME,
};
